const MainModel = function () {
  return {
    id: null,
    rfqid: null,
    chosen: false,
    qty: 1,
    partID: null,
    partSN: '',
    price: '',
    currencyID: null,
    conditionID: null,
    releaseID: null,
    traceabilityCompanyID: null,
    tagInfoCompanyID: null,
    tagDate: null,
    supplyDate: '',
    quoteDate: '',
    stockID: null,
    exchangeCoreValue: null,
    exchangeCoreValueCurrencyID: null,
    exchangeConditionID: null,
    coreDueDate: null,
    exchangeCoreReceived: false,
    sendMail: false,
    remarks: ''
  }
}
export {
  MainModel
}
